import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const FRENCH_SPEAKING_COUNTRIES = ['FR', 'BE', 'CH', 'CA', 'LU', 'MC'];

export const LanguageRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { i18n } = useTranslation();

  useEffect(() => {
    // Detect if this is a bot/crawler - don't redirect bots
    const userAgent = navigator.userAgent.toLowerCase();
    const isBot = /bot|crawler|spider|crawling|googlebot|bingbot|slurp|duckduckbot|baiduspider|yandexbot|facebookexternalhit|twitterbot|rogerbot|linkedinbot|embedly|quora link preview|showyoubot|outbrain|pinterest|developers\.google\.com|facebot|ia_archiver/i.test(userAgent);
    
    if (isBot) {
      // Bots should see content without redirects
      // Just set the language based on path
      const isOnFrenchPath = location.pathname.startsWith('/fr');
      i18n.changeLanguage(isOnFrenchPath ? 'fr' : 'en');
      return;
    }

    // Check if user has already set a preference
    const preferredLanguage = localStorage.getItem('preferredLanguage');
    
    if (preferredLanguage) {
      // User has made a choice, respect it
      i18n.changeLanguage(preferredLanguage);
      return;
    }

    // Only redirect on first visit without preference
    const hasRedirected = sessionStorage.getItem('hasLanguageRedirected');
    if (hasRedirected) return;

    // ONLY redirect on homepage - let users access other pages directly
    const isHomepage = location.pathname === '/' || location.pathname === '/fr';
    if (!isHomepage) {
      // Not homepage - just set language based on path, no redirect
      const isOnFrenchPath = location.pathname.startsWith('/fr');
      i18n.changeLanguage(isOnFrenchPath ? 'fr' : 'en');
      return;
    }

    // Detect if user is from French-speaking region
    const userLanguage = navigator.language || (navigator as any).userLanguage;
    const browserLang = userLanguage.split('-')[0];
    const userCountry = userLanguage.split('-')[1]?.toUpperCase();

    const isFrenchSpeaking = 
      browserLang === 'fr' || 
      (userCountry && FRENCH_SPEAKING_COUNTRIES.includes(userCountry));

    // Only redirect on homepage
    if (isFrenchSpeaking && location.pathname === '/') {
      // Redirect to French homepage
      sessionStorage.setItem('hasLanguageRedirected', 'true');
      i18n.changeLanguage('fr');
      navigate('/fr');
    } else if (!isFrenchSpeaking && location.pathname === '/fr') {
      // Redirect to English homepage
      sessionStorage.setItem('hasLanguageRedirected', 'true');
      i18n.changeLanguage('en');
      navigate('/');
    } else {
      // Set language without redirect
      const isOnFrenchPath = location.pathname.startsWith('/fr');
      i18n.changeLanguage(isOnFrenchPath ? 'fr' : 'en');
    }
  }, [navigate, location, i18n]);

  return null;
};
